import { render } from "./GoogleReviewPrompt.vue?vue&type=template&id=a684def8&scoped=true"
import script from "./GoogleReviewPrompt.vue?vue&type=script&lang=js"
export * from "./GoogleReviewPrompt.vue?vue&type=script&lang=js"

import "./GoogleReviewPrompt.vue?vue&type=style&index=0&id=a684def8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a684def8"]])

export default __exports__